// このリポジトリでは Node.js v20 以上であるため、Node.js のバージョンによる分岐はなし
// `Error: ` と `    at getCallStack` の行をスキップする
const STACKTRACE_OFFSET = 2;

// skip `"    at "`
const LINE_OFFSET = 7;

/**
 * based on https://github.com/pinojs/pino-caller/blob/v3.4.0/index.js#L17-L29
 */
export function getCallStack(skip = 0) {
  const callers = Error()
    .stack?.split("\n")
    .slice(STACKTRACE_OFFSET + skip)
    .map((s) => s.substring(LINE_OFFSET));
  return callers ?? [];
}
